import script from "./ProductCardBenefitsInternet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardBenefitsInternet.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardBenefitsInternet.vue?vue&type=style&index=0&id=38c5601e&lang=scss"

const __exports__ = script;

export default __exports__